import { Component, effect, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { AvListItem } from '../../Interfaces/av-list.interface';

@Component({
  selector: 'av-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './av-list.component.html',
  styleUrls: ['./av-list.component.scss'],
})
export class AvListComponent {
  readonly items = input<AvListItem[]>([]);
  readonly selectedItemId = model<string | null>(null);
  readonly itemSelectedId = output<string | null>();

  constructor() {
    this._initSelectedItem();
  }

  private _initSelectedItem(): void {
    effect(() => {
      const list = this.items();
      const current = this.selectedItemId();
      if (list.length > 0 && (current == null || current === '')) {
        const first = list[0];
        this.selectedItemId.set(first.id);
        this.itemSelectedId.emit(first.id);
      }
    });
  }
  selectItem(item: AvListItem): void {
    this.selectedItemId.set(item.id);
    this.itemSelectedId.emit(item.id);
  }
}